module.exports = "/subscriptions/assets/7484e113a0ac1f79cddaa361faf938bc.png";